import { useStore } from 'features/ListBuilder/infra/react/ListBuilderStore/useStore'

export const useSaveListState = () =>
  useStore(store => store.saveList.state)
